<div class="modal fade modal--alert" id="emergency-services-modal" tabindex="-1" role="dialog" aria-labelledby="emergency-services-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">

            <!-- Placeholder image -->
            <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3 class="font-normal">Before we start, do you require <strong>emergency assistance?</strong></h3>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a
            href="javascript:void(0);"
            (click)="createClaim(true)"
            data-dismiss="modal"
            class="button button--lg button--secondary">
            Yes
          </a>
          <a
            href="javascript:void(0);"
            (click)="createClaim(false)"
            data-dismiss="modal"
            class="button button--lg button--secondary">
            No
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
